module.exports = __webpack_public_path__ + "img/kr-product-intl-card2-img1.60479a8.png";